import { render } from "./CommonFooter.vue?vue&type=template&id=edb0bbaa&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"

import "./CommonFooter.vue?vue&type=style&index=0&id=edb0bbaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb0bbaa"]])

export default __exports__